import ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

const CustomerCommunicationWorkflowRoute: RouteType = {
  name: "Customer Communication Workflow",
  path: "/workflows/customer-communication",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Customer Communication Log",
      component: () => import("./CustomerCommunicationWorkflowHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./CustomerCommunicationWorkflow"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the wizard
      const commentsStore = rootStore.commentsStore as ServiceStore;
      const emailHistoryStore = rootStore.emailHistoryStore as ServiceStore;
      const activitiesStore = rootStore.activitiesStore as ServiceStore;
      const contactsStore = rootStore.contactsStore as ServiceStore;

      await Promise.all([
        commentsStore?.find(),
        emailHistoryStore?.find(),
        activitiesStore?.find(),
        contactsStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for customer communication:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    const store = (rootStore as any).customerCommunicationWorkflowStore;
    store?.reset();
  },
};

export default CustomerCommunicationWorkflowRoute;